import { InstagramCreator, InstagramCreatorCountry } from '@frontend/gql/social/graphql';

export interface CreatorProfileCardProps {
  username: string;
  email?: string | null;
  country?: InstagramCreatorCountry | null;
  totalFollowers?: number | null;
  isLoading: boolean;
}

export const useCreatorProfileCardProps = (
  creator: InstagramCreator | null,
  isLoading: boolean,
): CreatorProfileCardProps => {
  if (isLoading) {
    return {
      username: '',
      email: null,
      country: null,
      totalFollowers: null,
      isLoading: true,
    };
  }
  if (!creator) {
    return {
      username: 'N/A',
      email: null,
      country: null,
      totalFollowers: null,
      isLoading: false,
    };
  }

  return {
    username: creator.username,
    email: creator.email,
    country: creator.country,
    totalFollowers: creator.insights?.total?.followers,
    isLoading: false,
  };
};
